import appConfig from '../config/appConfig';
import * as marketTypes from '../consts/market/marketTypes';

const convertMarketNameIfNeed = () => {
    const baseMarketName = appConfig.getScpCloudTopicMarket();

    if (baseMarketName === marketTypes.UK) {
        const UK_LOCALIZATION_MARKET_NAME = 'uk';

        return getCompoundedScpCloudTopicMarket(UK_LOCALIZATION_MARKET_NAME);
    } else {
        return getCompoundedScpCloudTopicMarket();
    }
};

const getCompoundedScpCloudTopicMarket = (customCloudTopicMarket) => {
    const scpCloudTopicMarketPrefix = appConfig.getScpCloudTopicMarketPrefix();
    const scpCloudTopicMarket = customCloudTopicMarket ? customCloudTopicMarket : appConfig.getScpCloudTopicMarket();

    if (scpCloudTopicMarketPrefix) {
        const scpCloudTopicMarketParts = [scpCloudTopicMarket, scpCloudTopicMarketPrefix];
        const compoundedScpCloudTopicMarket = scpCloudTopicMarketParts.join('_');

        return compoundedScpCloudTopicMarket;
    }

    return scpCloudTopicMarket;
};

const currentMarket = () => convertMarketNameIfNeed();

const getMarketFullName = () => getCompoundedScpCloudTopicMarket();

export default {
    currentMarket,
    getMarketFullName,
};
